import { Injectable } from '@angular/core';
import { App } from '@capacitor/app';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  addUrlOpenListener(callback: (event: any) => void) {
    App.addListener('appUrlOpen', callback);
  }

  getLaunchUrl() {
    return App.getLaunchUrl();
  }
}
